<!--
 * @Author: 317473294@qq.com
 * @Date: 2023-05-09 09:24:59
 * @LastEditTime: 2024-09-29 22:27:01
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/dragTest.vue
-->
<template>
  <div>
    <vue-draggable-resizable>
      <p>你可以拖着我，按照自己的意愿调整大小。</p>
      <img src="../../static/logo.png" />
    </vue-draggable-resizable>

    <vue-draggable-resizable>
      <p>你可以拖着我，按照自己的意愿调整大小。</p>
      <img src="../../static/logo.png" />
    </vue-draggable-resizable>

    <vue-draggable-resizable>
      <p>你可以拖着我，按照自己的意愿调整大小。</p>
      <img src="../../static/logo.png" />
    </vue-draggable-resizable>
  </div>

  
</template>
<script>
  import { get,post,del,getBlob} from "../axios/index.js"
  export default {
    name: 'dragtest',
    data() {
      return {
        property: 'value',
      };
    },
    mounted() {
      //  this.getHands()
    },
    
    methods: {
      // getHands() {
      //   //console.log(this.baseURL+'test.json')
      //   get(this.baseURL+'test.json',{
      //     params:{
      //       age:10,
      //       name:"张三"
      //     }
      //   })
      //   .then((res) => {
      //     //console.log(res.data)
      // })
      // },
    },
  }
</script>
<style scoped>
  .vdring {
    background-color: pink;
  }
</style>


// WEBPACK FOOTER //
// src/components/dragTest.vue